// extracted by mini-css-extract-plugin
export default {"body":"toast_body__qymP2","title":"toast_title__9r6TZ"};